import actionTypes from './actionTypes';

const initialState = {
  currency: DEFAULT_CURRENCY,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...initialState,
      };

    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
      };

    case actionTypes.FETCHED:
      return {
        ...state,
        currency: action.payload.currency,
        isFetching: false,
      };

    default:
      return state;
  }
};
